import { getRuntimeConfig } from '../runtimeConfig';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';

const publicRuntimeConfig = getRuntimeConfig();

export const localErrorsToIgnore = [
  'ECONNREFUSED 127.0.0.1',
  'Cannot connect to Redis',
  'Connection is closed',
];

export function init() {
  // @ts-expect-error - .
  if (!Bugsnag._client) {
    Bugsnag.start({
      appVersion: publicRuntimeConfig.appVersion,
      apiKey: publicRuntimeConfig.bugsnagApiKey,
      plugins: [new BugsnagPluginReact()],
      enabledReleaseStages: ['production', 'staging', 'development'],
      releaseStage: publicRuntimeConfig.bugsnagEnvironment,
      onError: (event) => {
        if (publicRuntimeConfig.bugsnagEnvironment === 'development') {
          if (
            localErrorsToIgnore.some(
              (e) => event.originalError?.message?.indexOf(e) > -1
            )
          ) {
            return false;
          }

          console.error('Bugsnag Error', event.originalError);
          return false;
        }

        const isCFBotError =
          event.originalError?.message ===
            "Cannot read properties of undefined (reading 'document')" &&
          event.errors?.[0]?.stacktrace?.some(
            (frame) => frame.method === 'HTMLDocument.c'
          );

        if (isCFBotError) return false;

        return true;
      },
    });
  }
}
